// React&NextJS
import React, { useEffect, useState } from 'react'
// Context&Auth
import { useAuth } from '../../../context/UserContext'
// Services&Helper functions
import firestoreEditService from '../../../services/edit'
// Types
import { Memory as memoryType } from '../../../types/types'
// Styles
import s from './AcceptInvite.module.scss'
import c from 'classnames'
// Components
import { Button } from '../../core/button/Button'
import { Container } from '../../core/container/Container'
import { Text } from '../../core/text/Text'

type Props = {
    setFollowing: Function
    memory: memoryType
}

function AcceptInvite({ setFollowing, memory }: Props) {
    const { user, resetUserData } = useAuth()
    const [canAccept, setCanAccept] = useState(false)
    const [isOpen, setIsOpen] = useState(false)

    const { invitedEmails, mid } = memory

    useEffect(() => {
        let timer1 = setTimeout(() => setIsOpen(true), 300)

        return () => {
            clearTimeout(timer1)
        }
    }, [])

    useEffect(() => {
        const inv = invitedEmails.find((e) => e === user.email)
        if (inv) {
            setCanAccept(true)
            // append memory ref to user
        }
    }, [user])

    const accept = () => {
        if (invitedEmails.find((e) => e === user.email)) {
            firestoreEditService.appendMemoryToUser(mid, user.uid).then(() =>
                // remove invite from memory
                {
                    Promise.all([
                        firestoreEditService.appendUserToEditors(mid, user.uid),
                        firestoreEditService.removeInvite(mid, user.email),
                    ]).then((res) => {
                        if (res[0]) {
                            resetUserData()
                            setIsOpen(false)
                            setFollowing(null)
                        }
                    })
                }
            )
        } else {
            console.log('You do not have permission')
        }
    }

    if (canAccept) {
        return (
            <div className={c(s.sec, isOpen && s.open)}>
                <Container noGrid className={s.container}>
                    <Text className={s.text}>
                        Þér býðst að gerast umsjónaraðili að þessari
                        minningarsíðu
                    </Text>
                    <Button variant="ghost" invert onClick={accept}>
                        Samþykkja
                    </Button>
                </Container>
            </div>
        )
    }

    return <></>
}

export default AcceptInvite
